export const openAiRateLimitStats = "/generative_ai/rate_limit_stats";
